<template>
  <div class="map-container">
    <span
      v-show="isHover"
      :class="{ active: isHover }"
      ref="tooltip"
      class="tooltip"
      >{{ tooltipContent }}</span
    >
    <svg class="map" viewBox="0 0 990 560">
      <g>
        <MapPath
          v-for="region in regions"
          :key="region.regionCode + region.regionName"
          :region="region"
          :is-active="region.regionCode === regionCode"
          :disabled="disabled"
          @region-click="$emit('region-click', $event)"
          @region-mouseover="regionMouseoverHandler"
          @region-mouseout="isHover = false"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import MapPath from '@/components/map/MapPath';
import { RegionModule } from '@/store/modules/region';

export default {
  name: 'Map',
  components: { MapPath },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    regionCode: {
      type: String,
    }
  },
  data() {
    return {
      regions: RegionModule.map,
      isHover: false,
      tooltipContent: '',
    };
  },
  methods: {
    regionMouseoverHandler({ event, regionName }) {
      const EPS = 200;
      let mapElement = this.$el.getBoundingClientRect();
      if (mapElement.right - (event.pageX + 10) >= EPS) {
        this.$refs.tooltip.style.left = event.layerX + 20 + 'px';
        this.$refs.tooltip.style.top = event.layerY + 'px';
      } else {
        this.$refs.tooltip.style.left = event.layerX - 120 + 'px';
        this.$refs.tooltip.style.top = event.layerY - 70 + 'px';
      }

      this.isHover = true;
      this.tooltipContent = regionName;
    },
  },
};
</script>

<style scoped lang="scss">
.map {
  &::v-deep path {
    fill: #27ae60;
    cursor: pointer;
    transition: fill 0.3s;

    &:hover {
      fill: #77daa1;
    }

    &.is-active {
      fill: $color-base;
    }
  }
}

.map-container {
  position: relative;
}

.tooltip {
  background: white;
  padding: 5px;
  border-radius: $border-radius;
  position: absolute;
  z-index: 99;
  box-shadow: $box-shadow;
  border: 1px solid $color-dark-grey;
  opacity: 0;
  transition: opacity 5s;

  &.active {
    opacity: 1;
  }
}
</style>
